import script from "./TheTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTeam.vue?vue&type=script&setup=true&lang=js"

import "./TheTeam.vue?vue&type=style&index=0&id=04d28b36&scoped=true&lang=css"

import exportComponent from "D:\\Работа\\vue3\\_hackatons\\latest_version\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d28b36"]])

export default __exports__